import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { friends } from '../data/mockData';

export default function RightSidebar() {
  return (
    <aside className="hidden lg:flex flex-col w-72 bg-vinyl-900 border-l border-vinyl-700/50 h-full p-6">
      <div className="flex items-center justify-between mb-8">
        <h3 className="font-display font-semibold text-white">Friend Queue</h3>
        <button className="text-gray-400 hover:text-aqua transition-colors">
          <SafeIcon icon="FiUserPlus" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto space-y-6">
        {friends.map((friend) => (
          <div key={friend.id} className="flex items-start gap-3 group">
            <div className="relative">
              <img src={friend.avatar} alt={friend.name} className="w-10 h-10 rounded-full object-cover border border-vinyl-600 group-hover:border-aqua transition-colors" />
              <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-vinyl-900 ${
                friend.status === 'offline' ? 'bg-gray-500' : 'bg-aqua glow-aqua'
              }`} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-white truncate">{friend.name}</h4>
              <p className="text-xs text-gray-400 truncate mt-0.5">
                {friend.status === 'listening' && (
                  <span className="flex items-center gap-1 text-plasma">
                    <SafeIcon icon="FiMusic" className="text-[10px]" /> {friend.track}
                  </span>
                )}
                {friend.status === 'room' && (
                  <span className="flex items-center gap-1 text-aqua">
                    <SafeIcon icon="FiRadio" className="text-[10px]" /> {friend.roomName}
                  </span>
                )}
                {friend.status === 'offline' && 'Offline'}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-auto pt-6 border-t border-vinyl-700/50">
        <p className="text-[10px] text-center text-gray-600 uppercase tracking-widest font-display">
          Made by LingLink AI and DigLab AI
        </p>
      </div>
    </aside>
  );
}